import { TEAM } from "./data/content";
import Reveal from "./Reveal";
import PhotoSlot from "./PhotoSlot";

const Card = ({ m, i }) => (
  <article
    className={`group flex h-full flex-col rounded-2xl border border-white/10 bg-panel/60 p-6 transition-all duration-200 hover:-translate-y-1 hover:border-gold/40 sm:p-7 ${
      m.wide ? "lg:col-span-2" : ""
    }`}
    data-testid={`team-card-${i + 1}`}
  >
    <PhotoSlot
      file={m.photo}
      label={m.name}
      aspect={m.wide ? "aspect-[16/9] rounded-xl" : "aspect-[4/3] rounded-xl"}
      className={m.wide ? "lg:col-span-2" : ""}
    />
    <h3 className="mt-6 font-display text-lg font-bold tracking-tight text-white" data-testid={`team-name-${i + 1}`}>
      {m.name}
    </h3>
    <p className="label-mono mt-1.5 !text-[10px]">{m.role}</p>
    <p className="mt-4 text-sm leading-relaxed text-slate-400">{m.bio}</p>
  </article>
);

export const Team = () => (
  <section id="team" className="border-y border-white/10 bg-surface/50 py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <p className="label-mono">Leadership team</p>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          The people behind your business.
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-400 sm:text-lg">
          Not a helpdesk — an experienced leadership team that runs the operational side of your agency
          with you.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {TEAM.map((m, i) => (
          <Reveal key={m.role} delay={Math.min(i * 0.06, 0.3)} className={`h-full ${m.wide ? "sm:col-span-2 lg:col-span-2" : ""}`}>
            <Card m={m} i={i} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Team;
